
<paper-button routerLink="../">back to issue</paper-button>
<app-tangy-forms-player [skipSaving]="true" #formPlayer></app-tangy-forms-player>

